import { DepartmentWithCount } from '@EHSNavigator/backend';
import * as Yup from 'yup';

export const getEditDepartmentDetailsSchema = (
  currentDepartment: DepartmentWithCount,
) => {
  return Yup.object()
    .shape({
      name: Yup.string().required('Department Name is required'),
      prefix: Yup.string()
        .required('Department Prefix is required')
        .test(
          'is-uppercase',
          'Department Prefix must be uppercase',
          (value) => value === value?.toUpperCase(),
        ),
    })
    .test(
      'atLeastOneChanged',
      'At least one field must be changed',
      function (value) {
        return (
          value.name !== String(currentDepartment?.name) ||
          value.prefix !== String(currentDepartment?.prefix)
        );
      },
    );
};

export const getDeleteDepartmentSchema = (name: string) => {
  return Yup.object().shape({
    name: Yup.string()
      .oneOf(
        [`${name.trim().replace(/\s+/g, ' ')}`],
        `You must type "${name.trim().replace(/\s+/g, ' ')}" exactly`,
      )
      .required('Name is required'),
  });
};

export const getDepartmentSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Department Name is required'),
    prefix: Yup.string()
      .required('Department Prefix is required')
      .test(
        'is-uppercase',
        'Department Prefix must be uppercase',
        (value) => value === value?.toUpperCase(),
      ),
  });
};
